import React from 'react';

import { Form, InputField, SelectField } from 'components/Form';
import { Button, Dialog, DialogTitle, FullScreenSpinner } from 'components/Elements';
import { useNavigate } from 'react-router-dom';
import { Edit2 } from 'react-feather';
import { useChangeTransactionStatus } from '../api/changeTransactionStatus';
import { useTransaction } from '../api/getTransaction';

export const ChangeTransactionStatus = ({ tx_ref, id }) => {
  const [show, setShow] = React.useState(false);

  const navigate = useNavigate();
  const changeTransactionMutation = useChangeTransactionStatus();

  const transactionQuery = useTransaction({ tx_ref });

  if (transactionQuery.isLoading) {
    return <FullScreenSpinner />;
  }

  if (!transactionQuery.data) return null;

  const statusOptions = [
    { label: 'Select ...', value: '' },
    { label: 'Successful', value: 'successful' },
    { label: 'Failed', value: 'failed' },
  ];

  if (transactionQuery.data?.transactionDetails?.status === 'successful') return null;

  const handleClose = () => {
    setShow(false);
  };

  const handleOpen = () => {
    setShow(true);
  };

  return (
    <div className="">
      <div>
        <button
          className="flex flex-row items-center space-x-2 text-blue-500 rounded-md p-2 bg-blue-100"
          onClick={handleOpen}
        >
          <Edit2 size={12} /> <span>Change Status</span>
        </button>
        <Dialog isOpen={show} onClose={handleClose} initialFocus={null}>
          <div className="inline-block align-bottom bg-white rounded-2xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <DialogTitle className="text-xl text-center font-bold mb-4">
              Change Transaction Status
            </DialogTitle>
            <Form
              id="change-transaction-status"
              onSubmit={async (values) => {
                await changeTransactionMutation.mutateAsync({ data: { id, ...values } });
                handleClose();
              }}
              options={{
                defaultValues: {
                  // status: transactionQuery.data?.transactionDetails?.status,
                },
              }}
            >
              {({ register, formState }) => (
                <>
                  <SelectField
                    error={formState.errors['status']}
                    registration={register('status')}
                    options={statusOptions}
                  />
                  <div className="flex flex-row justify-end items-end">
                    <Button isLoading={changeTransactionMutation.isLoading} type="submit">
                      Submit
                    </Button>
                  </div>
                </>
              )}
            </Form>
          </div>
        </Dialog>
      </div>
    </div>
  );
};
